import React from "react";
import { useParams, Link } from "react-router-dom";
import "./CardDetail.css";

import mop1 from "../assets/Images/mopi11.jpg";
import mop2 from "../assets/Images/mopi22.jpg";
import mop3 from "../assets/Images/mopi33.jpg";
import mop4 from "../assets/Images/mopi44.jpg";

import cloth1 from "../assets/Images/cloth1.jpg";
import cloth2 from "../assets/Images/cloth2.jpg";
import cloth3 from "../assets/Images/cloth3.jpg";
import cloth4 from "../assets/Images/cloth4.jpg";

import handle1 from "../assets/Images/handle1.jpg";
import handle2 from "../assets/Images/handle2.jpg";
import handle3 from "../assets/Images/handle3.jpg";

import frame1 from "../assets/Images/frame1.jpg";
import frame2 from "../assets/Images/frame2.jpg";
import frame3 from "../assets/Images/frame3.jpg";

import misc1 from "../assets/Images/wiper11.jpg";
import misc2 from "../assets/Images/wiper22.jpg";
import misc3 from "../assets/Images/wiper33.jpg";

const categoriesData = {
  1: [mop1, mop2, mop3, mop4],
  2: [cloth1, cloth2, cloth3, cloth4],
  3: [handle1, handle2, handle3],
  4: [frame1, frame2, frame3],
  5: [misc1, misc2, misc3],
};

function CardDetail() {
  const { id } = useParams();
  const images = categoriesData[id] || [];
  const isOdd = images.length % 2 !== 0;

  return (
    <div className="card-detail-section">
      <div className="detail-container">
        <h2 className="detail-title">
          {id === "1" && "Explore Our Mops Categories"}
          {id === "2" && "Discover Eagle Cleaning Cloth Varieties"}
          {id === "3" && "Strong & Durable Handles Categories"}
          {id === "4" && "Frames & Holders Collection"}
          {id === "5" && "Miscellaneous Cleaning Accessories"}
        </h2>

        <div className={`categories-grid ${isOdd ? "categories-grid--odd" : ""}`}>
          {images.map((img, index) => (
            <Link
              key={index}
              to={`/card/${id}/category/${index + 1}`}
              className="category-card-new"
            >
              <div className="card-left">
                <img src={img} alt={`Category ${index + 1}`} />
              </div>
              <div className="card-right">
                <h3>Category {index + 1}</h3>
                <p>
                  High-quality cleaning product with professional performance.
                  Perfect for daily, durable, and efficient use.
                </p>
                <span className="details-link">Details →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CardDetail;